import { fetcherAmplify } from '../../Libraries/Fetcher';
import { ChatgptRepositoryImpl } from './ChatGPTRepositoryImpl';

const chatgptRepository = new ChatgptRepositoryImpl(fetcherAmplify);

export { chatgptRepository };
